import { useState } from "react";
import { PlusCircle } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/app/StatusBadge";
import { formatApiError } from "@/lib/api";
import { PayPalButton, startCheckout, usePayPal } from "@/components/billing/PlanCheckout";
import { useApp } from "@/lib/i18n";
import { fmtRM } from "@/config/plans";

export const TopupCard = ({ u, workspaceId, canManage, onDone }) => {
  const { L } = useApp();
  const [busy, setBusy] = useState("");
  const paid = u.plan.key !== "free";
  const low = u.minutes_left < 60 || u.credits_left < 3;
  const paypal = usePayPal();
  const buy = async (pack, provider = "stripe") => {
    setBusy(pack.key);
    try {
      await startCheckout({ workspace_id: workspaceId, kind: "topup", pack: pack.key }, provider);
    } catch (e) { toast.error(formatApiError(e)); setBusy(""); }
  };
  return (
    <Card id="topup" className={`mt-6 p-5 ${low && paid ? "border-amber-300 bg-amber-50/50" : ""}`} data-testid="topup-card">
      <h2 className="flex items-center gap-2 font-semibold"><PlusCircle size={17} className="text-violet-600" /> {L("Tambah kuota", "Add quota")}</h2>
      <p className="mt-1 text-sm text-slate-500">
        {!paid ? L("Tambah kuota tersedia untuk pelan berbayar (Lite, Pro, Team Asas).", "Top-ups are available on paid plans (Lite, Pro, Team Basic).")
          : low ? L("Kuota anda hampir habis. Tambah kuota untuk kitaran ini tanpa menukar pelan.", "Your quota is almost used up. Add quota for this cycle without changing plans.")
            : L("Perlukan lebih? Kuota tambahan sah sehingga akhir kitaran bil semasa.", "Need more? Extra quota is valid until the end of the current billing cycle.")}
        {(u.topup_minutes > 0 || u.topup_documents > 0) && <span className="ml-1 font-semibold text-slate-700" data-testid="topup-summary">{L(`Bulan ini: +${u.topup_minutes} minit, +${u.topup_documents} dokumen.`, `This month: +${u.topup_minutes} min, +${u.topup_documents} documents.`)}</span>}
      </p>
      <div className="mt-4 grid gap-3 sm:grid-cols-2">
        {u.topup_packs.map((p) => (
          <div key={p.key} className="flex items-center justify-between gap-3 rounded-xl border border-slate-200 bg-white p-4" data-testid={`topup-pack-${p.key}`}>
            <div className="mr-auto"><p className="font-semibold">{p.name}</p><p className="text-sm text-slate-500">RM{fmtRM(p.price_myr)}</p></div>
            <Button size="sm" disabled={!paid || !canManage || !!busy} onClick={() => buy(p)} className="rounded-xl bg-violet-600 hover:bg-violet-700" data-testid={`topup-buy-${p.key}`}>
              {busy === p.key ? L("Mengalih…", "Redirecting…") : L("Beli", "Buy")}
            </Button>
            {paypal && <PayPalButton onClick={() => buy(p, "paypal")} disabled={!paid || !canManage || !!busy} testId={`topup-paypal-${p.key}`} />}
          </div>
        ))}
      </div>
    </Card>
  );
};
